import type { ReportRun } from '@/lib/types';

const STEP_ORDER = ['gather', 'write', 'check', 'render', 'store'] as const;

const STEP_LABELS: Record<(typeof STEP_ORDER)[number], string> = {
  gather: 'Gathering data',
  write: 'Writing',
  check: 'Checking',
  render: 'Rendering',
  store: 'Saving',
};

/**
 * What an active engine run is doing now. A run records the last step it completed, so a running run is on the
 * step after it, and on gathering before it has completed any.
 */
export function runProgressLabel(run: Pick<ReportRun, 'status' | 'step'>): string {
  if (run.status === 'queued') return 'Queued';
  if (run.status !== 'running') throw new Error(`a ${run.status} run is not in progress`);
  const next = run.step === null ? 0 : STEP_ORDER.indexOf(run.step) + 1;
  if (next >= STEP_ORDER.length) return STEP_LABELS.store;
  return STEP_LABELS[STEP_ORDER[next]];
}
